var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.148,
    height: 18.151,
    viewBox: "0 0 18.148 18.151",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .call-cls-1 {\n        fill: none;\n        stroke: #a7a7be;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 1.2px;\n        fill-rule: evenodd;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Call",
    className: "call-cls-1",
    d: "M2.937,4.616C3.219,4.149,4.774,2.45,5.883,2.5a1.459,1.459,0,0,1,.863.461,15.039,15.039,0,0,1,2.2,2.978C9.163,6.982,7.921,7.583,8.3,8.634a8.8,8.8,0,0,0,5.011,5.009c1.05.38,1.65-.862,2.693-.645a15.064,15.064,0,0,1,2.978,2.2,1.461,1.461,0,0,1,.461.863c.041,1.168-1.763,2.744-2.115,2.945a3.088,3.088,0,0,1-3.232-.03C10.414,17.444,4.528,11.67,2.968,7.848,2.37,6.535,2.329,5.446,2.937,4.616Z",
    transform: "translate(-1.897 -1.899)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/Call.02013ea5.svg";
export { ForwardRef as ReactComponent };